import "../App.css";

interface SliderHandleProps {
  share: number; // 0 to 1 along the track
  label: string;
  tilt: string;
  grabbed: boolean;
}

// The visible thumb of an .outset-slider, drawn over the input's invisible
// native thumb so it can carry a label. A tilted sticker that peels up while
// grabbed.
export const SliderHandle: React.FC<SliderHandleProps> = ({
  share,
  label,
  tilt,
  grabbed,
}) => (
  <div
    className={`slider-handle${grabbed ? " is-grabbed" : ""}`}
    style={
      {
        left: `calc((100% - 44px) * ${share})`,
        "--tilt": tilt,
      } as React.CSSProperties
    }
  >
    {label}
  </div>
);

export default SliderHandle;
